import { Box } from '@mui/material';
import { CalcLaunchComponent } from './CalcLaunchComponent';
import { CalculatorComponent } from './CalculatorComponent';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
var selectCalc = function (state) { return state.calculator.showCalc; };
export var Calculator = function () { var showCalc = useSelector(selectCalc); return /*#__PURE__*/ _jsx("main", { className: "main-content container-fluid flex-shrink-0", children: /*#__PURE__*/ _jsx(Box, { className: 'row justify-content-center h-80', children: !showCalc ? /*#__PURE__*/ _jsx(CalcLaunchComponent, {}) : /*#__PURE__*/ _jsx(CalculatorComponent, {}) }) }); };
